import { render } from "./DialogImport.vue?vue&type=template&id=070470da"
import script from "./DialogImport.vue?vue&type=script&lang=js"
export * from "./DialogImport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__